import { render } from "./svg-chat.vue?vue&type=template&id=e6ff3b3c"
import script from "./svg-chat.vue?vue&type=script&lang=ts"
export * from "./svg-chat.vue?vue&type=script&lang=ts"
script.render = render

export default script